import styled from 'styled-components';
import { mediumUp } from '@honeybook/hbui/dist/styles/breakpoints';
import colors from '@honeybook/hbui/dist/styles/colors';
import is from 'styled-is';

export const AIChatIcon = styled.div<{ $disabled?: boolean }>`
    display: none;
    height: 40px;
    width: 40px;
    padding: 8px;
    background-color: ${colors.white};
    border: none;
    border-radius: 4px;
    box-shadow: 0 2px 8px 0 ${colors.black_005}, 0 0 0 1px ${colors.black_01};
    cursor: pointer;

    ${mediumUp} {
        height: 32px;
        width: 32px;
    }

    ${is('$disabled')`
        pointer-events: none;
        opacity: 0.5;
    `}

    i {
        width: 16px;
        height: 16px;
    }
`;
